// extracted by mini-css-extract-plugin
module.exports = {"container":"Dashboard_container__3DJBF","mainContent":"Dashboard_mainContent__3cjzj","page":"Dashboard_page__27YBW"};